import { render, staticRenderFns } from "./TenderHeader.vue?vue&type=template&id=921279b4"
import script from "./TenderHeader.vue?vue&type=script&lang=js"
export * from "./TenderHeader.vue?vue&type=script&lang=js"
import style0 from "./TenderHeader.vue?vue&type=style&index=0&id=921279b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports